import React from 'react';
import { useT } from '../contexts/LocaleProvider';

const TONE = {
  draft:     'badge--neutral',
  submitted: 'badge--info',
  approved:  'badge--ok',
  rejected:  'badge--bad',
};

export default function StatusBadge({ status }) {
  const t = useT();
  const tone = TONE[status] || TONE.draft;
  return <span className={`badge ${tone}`}>{t(`status.${status || 'draft'}`)}</span>;
}
